
import backendAddress from '../scripts/backendAddress';

import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

const slides = [
    { src: "/app//src//static//yellow.png", link: "/yellow-page" },
    { src: "/app//src//static//magenta.png", link: "/magenta-page" },
]

const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 1; 
  overflow: hidden;
  .swiper-button-next,
  .swiper-button-prev {
    color: rgba(255, 255, 255, 0.5); /* delikatna biel */
    transition: color 0.3s ease;
  }

  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    color: rgba(255, 255, 255, 1); /* pełna biel po najechaniu */
  }
`;

const SlideImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  position: relative;
`;
const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
`;

const StyledSwiperSlide = styled(SwiperSlide)`
  width: 100%;
  height: 100%;
`;
const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3); // delikatna przyciemniona warstwa
`;
export default function ImageSlider() {
  
    return (
      <SliderWrapper>
        <StyledSwiper
          modules={[Navigation, Autoplay, EffectFade]}
          navigation
          loop
          effect="fade"
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {slides.map((slide, index) => (
            <StyledSwiperSlide key={index}>
              <a href={slide.link || "#"} style={{ display: 'block', height: '100%' }}>
                <SlideImage image={backendAddress + slide.src}>
                  <Overlay />
                  {/* Tekst / CTA opcjonalnie */}
                </SlideImage>
              </a>
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>
      </SliderWrapper>
    );
  }